// extracted by mini-css-extract-plugin
module.exports = {"ComponentSpace":"ComponentSpace__ComponentSpace___20CWf"};